export const QUERY_KEY_USER_MODELS = 'UserModels'
